import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

/**
 * Frontend guard for finance sub-roles.
 *
 * `finance_role` values:
 *   - INVOICE   → access only to invoice/voucher pages
 *   - SUPPLIER  → access only to purchase-order / supplier pages
 *   - KEDUANYA  → access to both
 *
 * `scope` prop is "INVOICE" or "SUPPLIER". Non-finance roles (admin, etc.)
 * pass through unchanged. Out-of-scope finance users are redirected to
 * /finance/dashboard with a toast.
 */
export default function RequireFinanceScope({ scope, children }) {
  const { user } = useAuth();

  if (!user) return null;
  if (user.role !== "finance") return children;

  const fr = (user.finance_role || "KEDUANYA").toUpperCase();
  if (fr === "KEDUANYA" || fr === scope) return children;

  toast.error(`Akun finance Anda dikonfigurasi sebagai ${fr}. Modul ${scope} tidak diizinkan.`);
  return <Navigate to="/finance/dashboard" replace />;
}
